import { useMutation, useQueryClient } from "react-query"
import { QUERY_KEY_LISTS } from "./keys"
import { createCustomArtileList } from "../createCustomArticleList"
import { InfiniteState } from "../../hooks/types"
import { ShowCustomArticleListsResponse } from "../models"

export function useCreateCustomArticleList() {
    const queryClient = useQueryClient()

    return useMutation(createCustomArtileList, {
        onSuccess: (response) => {
            queryClient.setQueriesData<InfiniteState<ShowCustomArticleListsResponse>>(QUERY_KEY_LISTS, (prev) => {
                return {
                    ...prev,
                    pages:
                        prev?.pages.map((page, index) => ({
                            ...(response && index === 0
                                ? {
                                      ...page,
                                      data: {
                                          ...page.data,
                                          customArticleLists: [response.createdCustomList, ...page.data.customArticleLists],
                                      },
                                  }
                                : page),
                        })) ?? [],
                }
            })
        },
    })
}
